module.exports = __webpack_public_path__ + "img/roadmap-shama.201050d9.png";